var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.has_error_messages)?_c('div',_vm._l((_vm.error_messages),function(m){return _c('p',[_c('info-text',{attrs:{"kind":"danger"}},[_vm._v(_vm._s(m))])],1)}),0):_c('div',[_c('info-text',{attrs:{"kind":"success"}},[_vm._v("Angaben regelkonform")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }